import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-popup-preview',
  templateUrl: './popup-preview.component.html',
  styleUrls: ['./popup-preview.component.scss']
})
export class PopupPreviewComponent {
  @Input() visible: boolean = false;
  @Input() media: any;
  @Input() activeIndex: number = 0;
  @Input() isServer: Boolean = false;
  @Output() onClose = new EventEmitter<string>();

  baseImageId = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
  baseStreamVideo = environment.STORAGE_SERVICE_API_BASE_PATH_STREAM_VIDEO;

  onclose() {
    this.onClose.emit();
  }

  prev() {
    if(this.activeIndex === 0) return;
    this.activeIndex--;
  }

  next() {
    if(this.media.length - 1 === this.activeIndex) return;
    this.activeIndex++;
  }

  onMouseWheelImage(event: WheelEvent) {
    const container = document.querySelector('.image-item');
    if (container) {
      const delta = event.deltaY || event.detail;
      if (delta > 0) this.next();
      else if (delta < 0) this.prev();
      event.preventDefault();
    }
  }

  handleImageScroll(index: number): void {
    this.activeIndex = index;
  }

  isImage(file: any): boolean {
    return file.type.includes('image/');
  }

  isVideo(file: any): boolean {
      return file.type.includes('video/');
  }

  replaceWithDefaultImage(event: any): void {
    event.target.src = 'assets/images/user-management/default-image.jpg';
  }
}
